import myHeader from "../../components/header.vue"

export default{
    components: {
        myHeader
      },
}


// WEBPACK FOOTER //
// ./src/pages/banner3/banner.js